import {Observable} from 'rxjs';
import {ApiV0Administration} from '../api.v0.administration';
import {LoginRes, UserDetailsRes} from '../../../../contracts/v0/cp';
import {RestApiService} from '../../../rest-api.service';
import {SetPasswordReq} from '../../../../contracts/v0/administration/account.contracts';

export class ApiV0AdminAccounts {
    segment = '/accounts';

    constructor(
        v0: ApiV0Administration,
        private rest: RestApiService
    ) {
        this.segment = v0.segment + this.segment;
    }

    setPassword(id: number, dto: SetPasswordReq): Observable<LoginRes> {
        return this.rest.patch<SetPasswordReq, LoginRes>(`${this.segment}/${id}/setPassword`, LoginRes, dto);
    }

    lockout(id: number): Observable<UserDetailsRes> {
        return this.rest.patch<{}, UserDetailsRes>(`${this.segment}/${id}/lockout`, LoginRes);
    }

    unlock(id: number): Observable<UserDetailsRes> {
        return this.rest.patch<{}, UserDetailsRes>(`${this.segment}/${id}/unlock`, LoginRes);
    }
}